export default "__VITE_ASSET__D3BPJMl3__"